import { type ReactNode } from "react";

import { twMerge } from "tailwind-merge";

interface Props {
  content: ReactNode;
  className?: string;
}

export const Error = ({ content, className }: Props) => {
  return (
    <div
      className={twMerge(
        "flex flex-col items-center justify-center h-full w-full left-0 top-0 z-50",
        "overflow-hidden absolute text-lg font-medium",
        className,
      )}
    >
      {content}
    </div>
  );
};
